import { Helmet } from 'react-helmet-async';

export default function SEO({
  title = 'PrimeLogic Tech Solutions',
  description = 'PrimeLogic Tech Solutions drives digital innovation in East Africa with custom software, mobile apps, and AI solutions.',
  keywords = 'software development, mobile apps, web design, AI solutions, Nairobi, Kenya, tech company, digital transformation',
  canonicalUrl = typeof window !== 'undefined' ? window.location.href : '',
}) {
  return (
    <Helmet>
      {/* Standard Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content="PrimeLogic Tech Solutions" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}
